import React, { Component, Fragment } from 'react';
import Icon from '../../artzu-ui/src/Icon';

class ProgressHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      onClick,
      title,
      disable,
      back,
      persistentTitle,
      step
    } = this.props;

    return (
      <Fragment>
        <div className="apply__header--nav">
          {disable && !back ? null : (
            <div className="apply__mobile">
              {step === 0 && /applyMobile/.test(window.location.href) ? (
                <a href="/dashboard">
                  <Icon
                    className="apply__header--icon"
                    name="BackArrow"
                    size="1x"
                  />
                </a>
              ) : (
                <Icon
                  className="apply__header--icon"
                  name="BackArrow"
                  size="1x"
                  onClick={evt => {
                    onClick();
                    evt.stopPropagation();
                  }}
                />
              )}
            </div>
          )}
          {persistentTitle ? (
            <div className="apply__header--title-persistent">{title}</div>
          ) : null}
          <div className="apply__header--title">{title}</div>
        </div>
      </Fragment>
    );
  }
}

export default ProgressHeader;



// WEBPACK FOOTER //
// ./src/components/NycApply/Header.js